import { render, staticRenderFns } from "./SiloSupplierInvite.vue?vue&type=template&id=70abb27a"
import script from "./SiloSupplierInvite.vue?vue&type=script&lang=js"
export * from "./SiloSupplierInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports